import { useContext, useRef } from 'react';
import useSWR from 'swr';
import AddPopup from './popups/Add.jsx'
import VisitorContext from './VisitorContext.jsx';
import { localAxios } from '../../api.js';

const AddVisitorNew = () => {
    const {
        visitors,
        visitLocation, setVisitLocation,
        visitLocationId, setVisitLocationId,
        visitDate, setVisitDate,
    } = useContext(VisitorContext);
    const dateRef = useRef(null);

    const { data: locationsData, isLoading: locationsLoading, error: locationsError } = useSWR('/api/locations', localAxios);
    const locations = locationsData?.data ?? [];
    if (locationsError) console.error('GET /api/locations failed:', locationsError?.response?.status, locationsError?.message);

    const count = visitors.length;

    const openDatePicker = () => {
        try {
            dateRef.current?.showPicker();
        } catch {
            // showPicker not supported in this browser — native click behaviour applies
        }
    };

    const handleLocationChange = (e) => {
        const selectedId = Number(e.target.value);
        const selected = locations.find(l => l.id === selectedId);
        setVisitLocationId(selected?.id ?? null);
        setVisitLocation(selected?.location_name ?? '');
    };

    return (
        <div className="visitor-controls">
            <div className="visitor-controls__row">
                <label className="visitor-controls__label">Location</label>
                <select
                    className="visitor-controls__select"
                    value={visitLocationId ?? ''}
                    onChange={handleLocationChange}
                    disabled={locationsLoading}
                >
                    <option value="">-- Select Site --</option>
                    {locations.map(loc => (
                        <option key={loc.id} value={loc.id}>{loc.location_name}</option>
                    ))}
                </select>
            </div>
            <div className="visitor-controls__row">
                <label className="visitor-controls__label">When</label>
                <input
                    ref={dateRef}
                    type="date"
                    className="visitor-controls__date"
                    value={visitDate}
                    onChange={e => setVisitDate(e.target.value)}
                    onClick={openDatePicker}
                />
            </div>
            <div className="visitor-controls__row visitor-controls__row--count">
                <span className="visitor-controls__count">
                    {count} {count !== 1 ? 'people' : 'person'}
                </span>
                <AddPopup />
            </div>
        </div>
    );
};

export default AddVisitorNew;
